import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export default function QualityRoute({ children }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setStatus("unauth");
        return;
      }
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (!snap.exists()) {
          setStatus("unauth");
          return;
        }
        const data = snap.data();
        const allowed = data.isAdmin || data.category === "quality-control";
        setStatus(allowed ? "auth" : "unauth");
      } catch {
        setStatus("unauth");
      }
    });
    return () => unsub();
  }, []);

  if (status === "checking") {
    return (
      <div style={screen}>
        <div style={spinner} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (status === "unauth") {
    return (
      <div style={screen}>
        <style>{`
          @keyframes fadeIn { from { opacity:0; transform:translateY(8px);} to { opacity:1; transform:translateY(0);} }
        `}</style>
        <div style={topLine} />
        <div style={content}>
          <p style={label}>Access Restricted</p>
          <p style={heading}>Quality Control Members Only</p>
          <div style={divider} />
          <p style={sub}>Redirecting you to login…</p>
        </div>
        <div style={bottomLine} />
        <AutoRedirect />
      </div>
    );
  }

  return children;
}

function AutoRedirect() {
  const [go, setGo] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGo(true), 2500);
    return () => clearTimeout(t);
  }, []);
  return go ? <Navigate to="/login" replace /> : null;
}

// Inline styles — identical tokens to TeamRoute / ProtectedRoute
const screen = {
  position: "fixed",
  inset: 0,
  background: "#06120d",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "'Montserrat','Helvetica Neue',sans-serif",
};
const spinner = {
  width: 26,
  height: 26,
  border: "1.5px solid rgba(201,176,122,0.18)",
  borderTopColor: "rgba(201,176,122,0.75)",
  borderRadius: "50%",
  animation: "spin 0.85s linear infinite",
};
const topLine = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "1px",
  background:
    "linear-gradient(90deg,transparent,rgba(201,176,122,0.35),transparent)",
};
const bottomLine = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "1px",
  background:
    "linear-gradient(90deg,transparent,rgba(201,176,122,0.35),transparent)",
};
const content = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "14px",
  animation: "fadeIn 0.7s cubic-bezier(0.22,1,0.36,1) both",
};
const label = {
  margin: 0,
  fontWeight: 300,
  fontSize: "0.6rem",
  letterSpacing: "0.45em",
  textTransform: "uppercase",
  color: "rgba(201,176,122,0.5)",
};
const heading = {
  margin: 0,
  fontFamily: "'Cormorant Garamond',Georgia,serif",
  fontWeight: 300,
  fontSize: "clamp(1.4rem,4vw,2rem)",
  letterSpacing: "0.18em",
  color: "rgba(201,176,122,0.88)",
  textAlign: "center",
};
const divider = {
  width: "40px",
  height: "1px",
  background: "rgba(201,176,122,0.3)",
};
const sub = {
  margin: 0,
  fontWeight: 300,
  fontSize: "0.58rem",
  letterSpacing: "0.3em",
  textTransform: "uppercase",
  color: "rgba(201,176,122,0.35)",
};
